import { namePattern } from '../../InputPatterns';
import { InputProps } from './interface';
import { FC, useEffect, useState } from 'react';

declare const localStorage: any;

const FirstName: FC<InputProps> = ({ register, errors, asterisk, setValue, fullWidth }) => {
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    const storedValues = localStorage?.getItem('formData');
    setFirstName(JSON.parse(storedValues)?.first_name);
    firstName?.length && setValue('first_name', firstName, { shouldValidate: true });
  }, [firstName]);

  return (
    <>
      <div className={`relative md:mb-8 mb-[25px] w-full ${fullWidth ? "w-full" : "md:w-1/2"} group`}>
        {/* Label & input */}
        <input
          placeholder="text"
          className={`block px-3 py-2 peer h-10 w-full border border-gray-300 text-[#231f20] placeholder-transparent focus:outline-none rounded text-[13px] ${
            errors?.first_name && 'border-red-500 focus-visible:border-red-500'
          }`}
          {...register('first_name', namePattern)}
        />
        {errors.first_name ? (
          <label
            className={`capitalize absolute left-2 -top-[9px] text-red-500 text-xs leadin-[18px] transition-all peer-placeholder-shown:text-xs peer-placeholder-shown:leading-[18px]  peer-placeholder-shown:text-red-500 peer-placeholder-shown:-top-[9px] peer-focus:-top-[9px] peer-focus:text-red-500 peer-focus:text-xs pointer-events-none peer-focus:px-1 bg-white px-1 peer-focus:leading-[18px]`}
          >
            First name{asterisk && '*'}
          </label>
        ) : (
          <label
            className={`capitalize absolute left-2 -top-[9px] text-[#777777] text-xs leading-[18px] transition-all peer-placeholder-shown:text-[13px] peer-placeholder-shown:leading-5 peer-placeholder-shown:text-[#777777] peer-placeholder-shown:top-[10px] peer-focus:-top-[9px] peer-focus:text-[#777777] peer-focus:text-xs peer-focus:leading-[18px] pointer-events-none peer-focus:px-1 bg-white px-1`}
          >
            First name{asterisk && '*'}
          </label>
        )}

        {/* Error Message Container */}
        <p
          className={`${
            errors?.first_name?.type ? 'visible' : 'invisible'
          } text-red-500 md:text-[11px] text-[9px] leading-4 mt-[2px] absolute capitalize`}
        >
          {errors?.first_name?.type === 'required'
            ? 'This field is required'
            : errors?.first_name?.type === 'pattern'
            ? 'Enter a valid First name'
            : errors?.first_name?.type === 'minLength'
            ? 'First name should be atleast 2 characters'
            : errors?.first_name?.type === 'maxLength'
            ? 'First name should not be more than 20 characters'
            : 'Error'}
        </p>
      </div>
    </>
  );
};

export default FirstName;
